import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
import ChatNotification from './chatNotification'; // 引入通知工具类
import {ElMessageBox} from 'element-plus';
import { useStore } from '@/store';
import { createImCacheManager } from './im-cache';
let store = useStore();


const debugLog = (...args) => {
  if (true) {
    console.debug('[IM_SDK_LIB]', ...args);
  }
};

// 创建 SDK 实例
// `TencentCloudChat.create()` 方法对于同一个 `SDKAppID` 只会返回同一份实例
let chatClient = null;
let loginPromise = null;
const SDK_READY_TIMEOUT_MS = 15000;
const CHAT_CLIENT_TIMEOUT_MS = 10000;
const LOGIN_RETRY_INTERVAL_MS = 1500;
const createDeferred = () => {
	let resolve;
	let reject;
	const promise = new Promise((res, rej) => {
		resolve = res;
		reject = rej;
	});
	return { promise, resolve, reject };
};
const withTimeout = (promise, timeoutMs, message) => {
	if (!timeoutMs || timeoutMs <= 0) {
		return promise;
	}
	let timer = null;
	const timeoutPromise = new Promise((_, reject) => {
		timer = setTimeout(() => reject(new Error(message)), timeoutMs);
	});
	return Promise.race([promise, timeoutPromise]).finally(() => {
		if (timer) {
			clearTimeout(timer);
		}
	});
};
const isReadyTimeoutError = (error)=>{
	return !!(error && typeof error.message === 'string' && /chat sdk ready timeout/i.test(error.message));
}
const syncReadyStateFromSdk = (reason = '')=>{
	const readyBySdk = !!chatClient?.isReady?.();
	if(readyBySdk && !isReady){
		isReady = true;
		try{
			sdkReadyDeferred.resolve();
		}catch(e){}
		debugLog('sync ready state from sdk', { reason });
	}
	return readyBySdk;
}
let sdkReadyDeferred = createDeferred();
let chatClientInitDeferred = createDeferred();
let imCacheManager = null;
let create = (SDKAppID)=>{
	if(chatClient){
		debugLog('复用已有的 TencentCloudChat 实例');
		return chatClient;
	}
	debugLog('TencentCloudChat:',TencentCloudChat);
	let options = {
		SDKAppID,//您的即时通信 Chat 应用的 SDKAppID
	};
	chatClient = TencentCloudChat.create(options);
	imCacheManager = createImCacheManager({
		getChatClient: async () => getChatClient(CHAT_CLIENT_TIMEOUT_MS, true),
		getUserId: () => currentUserID
	});
	setOther();
	setEvent();
	chatClientInitDeferred.resolve(chatClient);
	debugLog('创建了新的 TencentCloudChat 实例', chatClient);
	return chatClient;
}
let getChatClient = async (timeoutMs = CHAT_CLIENT_TIMEOUT_MS, waitReady = true)=> {
	if (!chatClient) {
		await withTimeout(chatClientInitDeferred.promise, timeoutMs, 'chat client init timeout');
	}
	if(waitReady){
		if(syncReadyStateFromSdk('getChatClient-precheck')){
			window.__IM_CACHE_DEBUG__.chatClient = chatClient;
			return chatClient;
		}
		try{
			await awaitReady();
		}catch(err){
			const readyBySdk = syncReadyStateFromSdk('getChatClient-timeout-catch');
			const loginUser = chatClient?.getLoginUser?.();
			if(isReadyTimeoutError(err) && (readyBySdk || !!loginUser)){
				debugLog('chat sdk ready timeout but client is still logged in, use degraded ready mode', { readyBySdk, loginUser });
				
				window.__IM_CACHE_DEBUG__.chatClient = chatClient;
				return chatClient;
			}
			throw err;
		}
	}
	
	window.__IM_CACHE_DEBUG__.chatClient = chatClient;
	return chatClient;
};

let registerEventsQueue = [];

// 注册事件
const registerEvent = (event,handler) => {
	// 添加事件处理器
	return registerEvents([{event, handler}]);
};
const registerEvents = (events) => {
	debugLog(`注册事件处理器: `,events);
	// 添加事件处理器
	events.forEach(e=>{
		if(chatClient){
			chatClient.on(e.event, e.handler);
		}else{
			registerEventsQueue.push(()=>{
				chatClient.on(e.event, e.handler);
			})
		}
	})
	return {
		unregister:()=>unregisterEvents(events),
	}
};
// 注销事件
const unregisterEvents = (events) => {
	debugLog(`注销事件处理器: `,events.map(e=>e.event).join('、'));
	events.forEach(e=>{
		chatClient.off(e.event,e.handler);
	})
};
let onKickedOut = function(event) {
		// debugLog(event.data.type);
		let TYPES = [
			{value:TencentCloudChat.TYPES.KICKED_OUT_MULT_ACCOUNT,lable:'Web端，同一账号，多页面登录被踢',},
			{value:TencentCloudChat.TYPES.KICKED_OUT_MULT_DEVICE,lable:'同一账号，多端登录被踢',},
			{value:TencentCloudChat.TYPES.KICKED_OUT_USERSIG_EXPIRED,lable:'签名过期',},
			{value:TencentCloudChat.TYPES.KICKED_OUT_REST_API,lable:'REST API kick 接口踢出',},
		];
		let has = TYPES.find(e=>e.value == event.data.type);
		if(has){
			debugLog('onKickedOut-1:',has.lable);
			// 踢下线重新登录
			setTimeout(()=>{
				login({
					userId:currentUserID,
					request:lastRequset,
					kickouted:true,
				})
			},3000)
		}
	};
let sdkReady = (e)=>{
	debugLog('SDK Ready');
	isReady = true;
	sdkReadyDeferred.resolve();
}
let sdkNotReady = (e)=>{
	debugLog('SDK Not Ready');
	if(isReady){
		sdkReadyDeferred = createDeferred();
	}
	isReady = false;
	setTimeout(()=>{
		syncReadyStateFromSdk('sdkNotReady-post-check');
	}, 200);
}

const wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
	
let setEvent = ()=>{
	chatClient.on(TencentCloudChat.EVENT.KICKED_OUT, onKickedOut);
	chatClient.on(TencentCloudChat.EVENT.SDK_READY, sdkReady);
	chatClient.on(TencentCloudChat.EVENT.SDK_NOT_READY, sdkNotReady);
	
	
	// 新增：监听新消息事件（腾讯 Chat 事件名以实际文档为准）
	chatClient.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onNewMessage);
	chatClient.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onCacheMessageReceived);
	chatClient.on(TencentCloudChat.EVENT.MESSAGE_REVOKED, onCacheMessageRevoked);
	// 必须先注册缓存更新回调，确保会话缓存先于业务层同事件回调刷新。
	chatClient.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, onCacheConversationListUpdated);
	chatClient.on(TencentCloudChat.EVENT.MESSAGE_READ_RECEIPT_RECEIVED, onCacheMessageReadReceipt);
	
	registerEventsQueue.forEach(e=>e());
}
let setOther = ()=>{
	// 设置 SDK 日志级别
	// 0: 普通级别，日志量较多，接入时建议使用
	// 1: release 级别，SDK 输出关键信息，生产环境时建议使用
	chatClient.setLogLevel(0);
	// chatClient.setLogLevel(1);
	
	// 注册腾讯云即时通信 Chat 上传插件
	chatClient.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});
}

// 存储当前登录状态和用户信息
let isLoggedIn = false;
let isReady = false;
// 我方业务ID
let currentUserID = null;
// 腾讯用户ID
let currentUser = null;
// 声网Token
let currentToken = null;

let lastRequset = null;
const resetLoginState = ()=>{
	isLoggedIn = false;
	isReady = false;
	currentUser = null;
	currentUserID = null;
	currentToken = null;
}
// 获取token并登录
const login = async ({userId, request,kickouted}) => {
	debugLog('RTC登录userId',userId,currentUserID);
	if(loginPromise){
		debugLog('RTC复用进行中的登录Promise');
		return loginPromise;
	}
	// 如果已经登录，直接返回
	if (isLoggedIn && currentUserID == userId && !kickouted) {
		debugLog('Already logged in as', userId);
		return {succ: true, msg: "重复登录"};
	}
	if(!request){
		return {succ: false, msg: '请求实例不存在'};
	}
		// if(!userId){
		// 	return Promise.reject({succ: false, msg: "用户未登录"});
		// }
		debugLog('RTC-userId',userId);
		debugLog('RTC-currentUserID',currentUserID);
	loginPromise = (async()=>{
		let attempt = 0;
		while(true){
			attempt++;
			try {
				await getChatClient(CHAT_CLIENT_TIMEOUT_MS, false);
				// 如果当前有其他用户登录，先登出
				if (isLoggedIn) {
					debugLog('Logging out current user before login new user');
					await logout();
				}
				var resToken = await request({
					url: '/ChatRoomToken',
					method: 'post',
					data:{
						kickouted
					},
					notips:true,
				})
				lastRequset = request;
				debugLog('ChatRoomToken',resToken);
				var data = resToken&&resToken.data;
				if(data?.code != 200){
					throw new Error('无法获取到登录token!');
				}
				if(!data.data || !data.data.userID || !data.data.token) {
					throw new Error('从业务服务器获取到了意料之外的数据！');
				}
				const options = {
					userID: data.data.userID,
					userSig: data.data.token,
				};
				if(!chatClient){
					throw new Error('chatClient未初始化');
				}
				debugLog("即将登录腾讯RTC - options", options);
				let loginRes = await chatClient.login(options);
				debugLog("腾讯RTC登录结果：", loginRes);
			
				currentUserID = userId;
				debugLog('RTC登录userId-currentUserID',userId,currentUserID);
			
				currentUser = data.data.userID;
				currentToken = data.data.token;
				isLoggedIn = true;
				let readyTimeout = false;
				try{
					await awaitReady(SDK_READY_TIMEOUT_MS);
				}catch(err){
					if(isReadyTimeoutError(err) && chatClient?.getLoginUser?.() === data.data.userID){
						readyTimeout = true;
						debugLog('login succeeded but sdk ready timeout, continue with degraded mode', {
							loginUser: chatClient?.getLoginUser?.(),
						});
					}else{
						throw err;
					}
				}
				await imCacheManager?.onLoginSuccess();
				if(!readyTimeout){
					const notificationStatus = await ChatNotification.init();
					if (notificationStatus === 'pending' || notificationStatus == false) {
						debugLog('通知权限待授权，请引导用户点击授权按钮');
						if(store.state.notification){
							showPermissionGuide();
						}
					}
				}
				// 由于服务端帮更新，这里不用再更新用户名称了
				// try{
				// 	let myProfile = await chatClient.getMyProfile();
				// 	if(myProfile && !myProfile.data?.nick){
				// 		let _userInfo = instance.localStorage.getItem('userInfo');
				// 		let userInfo = {};
				// 		if(_userInfo){
				// 			userInfo = JSON.parse(_userInfo);
				// 			if(userInfo.id){
				// 				const options = {
				// 					nick: userInfo.nickName||'',
				// 					avatar: userInfo.photo||'',
				// 				};
				// 				let updateMyProfileRes = await chatClient.updateMyProfile(options);//更新腾讯RTC个人信息
				// 				debugLog('因登录后缺少nick信息，而更新了腾讯RTC个人信息：',updateMyProfileRes);
				// 			}
				// 		}
				// 	}
				// }catch(profileErr){
				// 	debugLog('getMyProfile/updateMyProfile skipped due sdk transient not-ready', profileErr);
				// }
				return {succ: true}
			} catch (error) {
				console.error('Error during login process:', error);
				const loginUser = chatClient?.getLoginUser?.();
				if(!(isReadyTimeoutError(error) && !!loginUser)){
					resetLoginState();
				}
				debugLog('RTC登录失败，准备重试', { attempt, error });
				await wait(LOGIN_RETRY_INTERVAL_MS);
			}
		}
	})();
	try{
		return await loginPromise;
	}finally{
		loginPromise = null;
	}
};
const showPermissionGuide = async () => {
	if(instance.localStorage.getItem('showPermissionGuide')){
		return
	}else{
		instance.localStorage.setItem('showPermissionGuide',true);
	}
	const userAgent = navigator.userAgent;
	let guideMessage = '';
	const origin = window.location.origin; // 当前站点域名（如 https://localhost:8080）
	
	// 分浏览器生成具体的操作步骤
	if (userAgent.includes('Chrome') || userAgent.includes('Edge')) {
		// Chrome/Edge：提示用户点击地址栏的锁形图标（最便捷的方式，无需跳转设置）
		guideMessage = `
		您还没有开启通知权限，请按照以下步骤操作：<br/>
		1. 点击浏览器地址栏左侧的「锁形图标」（或「感叹号图标」）；<br/>
		2. 在弹出的菜单中，找到「通知」选项，选择「允许」；<br/>
		3. 刷新页面后即可接收通知。<br/>
		<small>（若上述方式无效，可手动打开浏览器设置：设置 > 隐私和安全 > 网站设置 > 通知 > 找到 ${origin} 并允许）</small>
		`;
	} else if (userAgent.includes('Firefox')) {
		guideMessage = `
		您还没有开启通知权限，请按照以下步骤操作：<br/>
		1. 点击浏览器地址栏左侧的「锁形图标」；<br/>
		2. 选择「更多信息」；<br/>
		3. 在「权限」标签下，找到「通知」并勾选「允许」；<br/>
		<small>（若上述方式无效，可手动打开 Firefox 偏好设置：隐私与安全 > 网站权限 > 通知 > 添加 ${origin} 并允许）</small>
		`;
	} else if (userAgent.includes('Safari')) {
		guideMessage = `
		您还没有开启通知权限，请按照以下步骤操作：<br/>
		1. 点击 Safari 顶部菜单栏的「Safari」>「设置」（或按 Command + ,）；<br/>
		2. 切换到「网站」标签，左侧选择「通知」；<br/>
		3. 找到 ${origin}，选择「允许」；<br/>
		4. 刷新页面后即可接收通知。
		`;
	} else {
		guideMessage = '您还没有开启通知权限，请前往浏览器的「设置 > 隐私和安全 > 通知」中开启对当前站点的通知权限。';
	}
	// 显示 Element Plus 弹窗（支持 HTML 格式）
	await ElMessageBox({
		title: '提示',
		message: guideMessage,
		dangerouslyUseHTMLString: true, // 允许渲染 HTML（关键：显示换行和步骤）
		confirmButtonText: '我知道了',
		showCancelButton: false
	}).then(()=>{}).catch(()=>{});
}
const awaitReady = async(timeoutMs = SDK_READY_TIMEOUT_MS)=>{
	if(syncReadyStateFromSdk('awaitReady-precheck')){
		return;
	}
	if(isReady){
		return;
	}
	await withTimeout(sdkReadyDeferred.promise, timeoutMs, 'chat sdk ready timeout');
}
// 登出
const logout = async () => {
	if (!isLoggedIn) {
		debugLog('Not logged in, no need to logout');
		return Promise.resolve();
	}
	await chatClient.logout().then((res)=>{
		resetLoginState();
		debugLog('Logout successful',res.data);
	})
};


let destroy = ()=>{
	chatClient.off(TencentCloudChat.EVENT.KICKED_OUT, onKickedOut);
	chatClient.off(TencentCloudChat.EVENT.SDK_READY, sdkReady);
	chatClient.off(TencentCloudChat.EVENT.SDK_NOT_READY, sdkNotReady);

  
	// 新增：移除新消息监听
	chatClient.off(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onNewMessage);
	chatClient.off(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onCacheMessageReceived);
	chatClient.off(TencentCloudChat.EVENT.MESSAGE_REVOKED, onCacheMessageRevoked);
	chatClient.off(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, onCacheConversationListUpdated);
	chatClient.off(TencentCloudChat.EVENT.MESSAGE_READ_RECEIPT_RECEIVED, onCacheMessageReadReceipt);
	chatClient&&chatClient.destroy();
	// 关闭所有通知
	ChatNotification.closeAllNotifications();
}
let onCacheMessageReceived = async (event)=>{
	let _userInfo = instance.localStorage.getItem('userInfo');
	let userInfo = {};
	if(_userInfo){
		userInfo = JSON.parse(_userInfo);
	}
	try{
		let data = event?.data || [];
		data = data.filter(_e=>{
			let e = JSON.parse(JSON.stringify(_e));
			if(e.type == TencentCloudChat.TYPES.MSG_CUSTOM){
				try{
					if(typeof e.payload.data == 'string' && e.payload.data!==''){
						e.payload.data = JSON.parse(e.payload.data);
					}
				}catch(err){
					console.log(err);
				}
			}
			if(e.type == TencentCloudChat.TYPES.MSG_GRP_TIP && e.payload.operationType == 7 ||
				(e.type == TencentCloudChat.TYPES.MSG_CUSTOM &&
				e.payload.data?.event == 'redPacketReceive' && 
				e.payload.data.data.senderId != userInfo.id)//红包回调，不是自己的红包不要
			){
				return false;//过滤掉群提示信息的类型7
			}else{
				return true;
			}
		})
		await imCacheManager?.handleMessageReceived(data);
	}catch(err){
		debugLog('onCacheMessageReceived failed', err);
	}
}
let onCacheMessageRevoked = async()=>{
	try{
		let data = event?.data || [];
		data.forEach(e=>{
			e.isRevoked = true;
		})
		await imCacheManager?.handleMessageReceived(data);
	}catch(err){
		debugLog('onCacheMessageRevoked failed', err);
	}
}
let onCacheConversationListUpdated = async (event)=>{
	try{
		let list = event?.data || [];
		await imCacheManager?.handleConversationListUpdate(list);
	}catch(err){
		debugLog('onCacheConversationListUpdated failed', err);
	}
}
let onCacheMessageReadReceipt = (e)=>{
	e.data.forEach(item=>{
		let conversationID = '',conversationType='';
		if(item.userID){
			conversationID = `C2C${item.userID}`;
			conversationType = 'C2C';
		}else if(item.groupID){
			conversationID = `GROUP${item.groupID}`;
			conversationType = 'GROUP';
		}
		Object.assign(item,{
			conversationID,
			conversationType,
		})
	})
	let messages = e.data.filter(e=>e.conversationID);
	// console.log('收到已读事件-来更新',messages);
	return imCacheManager?.handleMessageReadReceipt(messages);
}
// 新增：监听新消息事件
let onNewMessage = async (event) => {
  // debugLog('收到新消息:', event);
  // debugLog('notification',store.state.notification);
  if(!store.state.notification)return;//未开启通知
  for (var message of event.data){
	// 1. 解析消息内容（根据腾讯 Chat 消息格式调整）
	let title = '新聊天消息';
	let body = '';
	let sender = message.from || '未知用户';
	let avatar = '';

	// 文本消息
	if (message.payload.text) {
		body = message.payload.text;
	}
	// 图片/文件等非文本消息
	else if (message.payload.file) {
		body = '[收到一个文件]';
	} else if (message.payload.image) {
		body = '[收到一张图片]';
	}

	// 2. 触发通知
	await ChatNotification.triggerNewMessage({
		title,
		body,
		sender,
		avatar
	});
	}
};

let getFriendList = async ()=>{
	// 腾讯 SDK 的 getFriendList 本身基于 SDK 内部缓存，并由 FRIEND_LIST_UPDATED 事件增量更新。
	// 这里仅确保 SDK 已就绪后，直接透传 SDK 接口。
	return (await getChatClient()).getFriendList();
}

let getConversationList = async ()=>{
	if(imCacheManager){
		return imCacheManager.getConversationList();
	}
	return (await getChatClient()).getConversationList();
}

let getMessageList = async (options, otherOptions)=>{
	if(imCacheManager){
		return imCacheManager.getMessageList(options,otherOptions);
	}
	return (await getChatClient()).getMessageList(options);
}

	let writeMsgsExt = async (conversationID, extMap = {})=>{
		if(imCacheManager?.writeMsgsExt){
			return imCacheManager.writeMsgsExt(conversationID, extMap);
		}
		return { updatedIds: [], missedIds: [] };
	}

	let writeMsgExt = async (conversationID, messageID, ext = {})=>{
		if(imCacheManager?.writeMsgsExt){
			let extMap = {};
			extMap[messageID] = ext;
			return imCacheManager.writeMsgsExt(conversationID, extMap);
		}
		return { updatedIds: [], missedIds: [] };
	}

	let readMsgsExt = async (conversationID, messageIDs = [])=>{
		if(imCacheManager?.readMsgsExt){
			return imCacheManager.readMsgsExt(conversationID, messageIDs);
		}
		return {};
	}

	let readMsgExt = async (conversationID, messageID)=>{
		if(!conversationID || !messageID){
			return {};
		}
		if(imCacheManager?.readMsgsExt){
			return (await imCacheManager.readMsgsExt(conversationID, [messageID]))[messageID] || {};
		}
		return {};
	}

	let getMsgExt = (message)=>{
		if(imCacheManager?.getMsgExt){
			return imCacheManager.getMsgExt(message);
		}
		return {};
	}

	let setMsgExt = (message, ext = {})=>{
		if(imCacheManager?.setMsgExt){
			return imCacheManager.setMsgExt(message, ext);
		}
		return {};
	}

	// 与 SDK 原型保持一致：sendMessage(message, options?)
	// 发送成功后用返回的真实 Message 回灌缓存，覆盖“本端发送不触发 MESSAGE_RECEIVED”场景。
	let sendMessage = async (message, options)=>{
		const client = await getChatClient();
		await imCacheManager?.handleMessageReceived([message]);
		const res = await client.sendMessage(message, options);
		try{
			const sentMessage = res?.data?.message;
			if(sentMessage){
				await imCacheManager?.handleMessageReceived([sentMessage]);
			}
		}catch(err){
			debugLog('sendMessage cache sync failed', err);
		}
		return res;
	}
	// 
	let userLocalRevokeMessage = async(users,conversationID)=>{
		await imCacheManager?.userRevokeMessage(users,conversationID);
	}
	let revokeMessage = async(message)=>{
		const client = await getChatClient();
		const res = await client.revokeMessage(message);
		try{
			if(res?.data?.message){
				await imCacheManager?.handleMessageReceived([message]);
			}
		}catch(err){
			debugLog('revokeMessage cache sync failed', err);
		}
		return res;
	}
	let deleteMessage = async(messages)=>{
		const client = await getChatClient();
		const res = await client.deleteMessage(messages);
		try{
			if(res?.data){
				await imCacheManager?.deleteMessage(messages);
			}
		}catch(err){
			debugLog('deleteMessage cache sync failed', err);
		}
		return res;
	}
	let updateMessage = async(messages)=>{
		return imCacheManager?.handleMessageReceived(messages);
	}

	let getImCacheStats = ()=>{
		return imCacheManager?.getDebugStats?.() || null;
	}

	let printImCacheStats = ()=>{
		return imCacheManager?.printDebugStats?.() || null;
	}

	let resetImCacheStats = ()=>{
		return imCacheManager?.resetDebugStats?.() || null;
	}

	let setImCacheVerboseTrace = (enabled)=>{
		imCacheManager?.setVerboseTrace?.(enabled);
	}
	
// export default {
// 	TencentCloudChat,
// 	getChatClient,
// 	create,
// 	destroy,
// 	login,
// 	logout,
// 	registerEvent,
// 	registerEvents,
// 	isLoggedIn: () => isLoggedIn,
// }
let instance = null;
export default class{
	TencentCloudChat = TencentCloudChat;
	getChatClient = getChatClient;
	create = create;
	destroy = destroy;
	login = login;
	logout = logout;
	registerEvent = registerEvent;
	registerEvents = registerEvents;
	getFriendList = getFriendList;
	getConversationList = getConversationList;
	getMessageList = getMessageList;
	writeMsgsExt = writeMsgsExt;
	writeMsgExt = writeMsgExt;
	getMsgExt = getMsgExt;
	setMsgExt = setMsgExt;
	readMsgsExt = readMsgsExt;
	readMsgExt = readMsgExt;
	sendMessage = sendMessage;
	getImCacheStats = getImCacheStats;
	printImCacheStats = printImCacheStats;
	resetImCacheStats = resetImCacheStats;
	setImCacheVerboseTrace = setImCacheVerboseTrace;
	revokeMessage = revokeMessage;
	userLocalRevokeMessage = userLocalRevokeMessage;
	deleteMessage = deleteMessage;
	updateMessage = updateMessage;
	isLoggedIn = () => isLoggedIn;
	// 暴露通知工具方法
	ChatNotification = ChatNotification;
	constructor(_instance){
		instance = _instance;
		if(typeof window !== 'undefined'){
			window.__IM_CACHE_DEBUG__ = {
				getStats: () => getImCacheStats(),
				printStats: () => printImCacheStats(),
				resetStats: () => resetImCacheStats(),
				setVerboseTrace: (enabled) => setImCacheVerboseTrace(enabled),
			};
		}
		debugLog('构造器中的实例',instance);
	}
}
